import { useMutation } from 'platform/useMutation';
import { gql } from '@apollo/client';
import { GET_ALL_EXTERIOR_ASSESSMENT_SLOTS } from 'sellDirect/graphql/useGetAllExteriorAssessmentSlots';
import {
  CancelExteriorAssessment as ICancelExteriorAssessment,
  CancelExteriorAssessmentVariables,
  CancelExteriorAssessment_web_cancelExteriorAssessment as ExteriorAssessmentMutationResult,
} from 'sellDirect/graphql/__generated__/CancelExteriorAssessment';

export const CANCEL_EXTERIOR_ASSESSMENT = gql`
  mutation CancelExteriorAssessment($sellerInputUUID: String!, $visitId: String!) {
    web {
      cancelExteriorAssessment(input: { sellerInputUUID: $sellerInputUUID, visitId: $visitId }) {
        visitId
      }
    }
  }
`;

const transformData = (
  data?: ICancelExteriorAssessment | null,
): Omit<ExteriorAssessmentMutationResult, '__typename'> | undefined => {
  if (!data?.web?.cancelExteriorAssessment) return;
  const assessmentData = data?.web?.cancelExteriorAssessment;

  return {
    visitId: assessmentData?.visitId,
  };
};

/** TODO: Add documentation */
export const useCancelExteriorAssessment = (sellerInputUUID: string) => {
  const [CancelExteriorAssessment, { data, loading, error }] = useMutation<
    ICancelExteriorAssessment,
    CancelExteriorAssessmentVariables
  >(CANCEL_EXTERIOR_ASSESSMENT, {
    awaitRefetchQueries: true,
    fetchPolicy: 'no-cache',
    refetchQueries: [{ query: GET_ALL_EXTERIOR_ASSESSMENT_SLOTS, variables: { sellerInputUUID } }],
  });

  const cancelExteriorAssessment = (visitId: string) => {
    CancelExteriorAssessment({
      variables: {
        sellerInputUUID,
        visitId,
      },
    });
  };

  return { cancelExteriorAssessment, data: transformData(data), loading, error };
};
